const TRACKER_PARAM = '?tracker=pdp_combo_offer'

const HREF_FINDER_REGEX = /(href=")(.*?)(")/g

const getTrackerParam = (productId: number) => `${TRACKER_PARAM}&source_product_id=${productId}`

export const getTrackerAddedComboMessageOffer = (content: string, productId: number) =>
  content.replace(HREF_FINDER_REGEX, (match, p1, p2, p3) => `${p1}${p2}${getTrackerParam(productId)}${p3}`)
